import * as React from 'react';
import { JSON_TEXT } from '@constants/common';
import {
  QUERY_PARAMETERS_DESCRIPTION,
  QUERY_PARAMETERS_TEXT_INPUT_PLACEHOLDER,
} from '@constants/search';
import { CodeEditor } from '@components/CodeEditor/CodeEditor';
import styles from './QueryParamsContent.module.scss';

interface IQueryParamsContentProps {
  value: string;
  onChange: (_: string) => void;
  error: string | null;
}

const QueryParamsContent: React.FC<IQueryParamsContentProps> = ({ value, onChange, error }) => {
  return (
    <div className={styles.paramsContent}>
      <h6 className={styles.paramsHeader}>{JSON_TEXT}</h6>
      <CodeEditor
        code={value}
        language="json"
        height={120}
        width="348px"
        onChange={onChange}
        maxHeight={300}
        placeholder={JSON.stringify(QUERY_PARAMETERS_TEXT_INPUT_PLACEHOLDER, null, 4)}
      />
      {!!error && <p className={styles.errorMessage}>{error}</p>}
      <p className={styles.paramsDescription}>{QUERY_PARAMETERS_DESCRIPTION}</p>
    </div>
  );
};

export default QueryParamsContent;
